import { render, staticRenderFns } from "./mchTable.vue?vue&type=template&id=09a13d35&scoped=true&"
import script from "./mchTable.vue?vue&type=script&lang=js&"
export * from "./mchTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a13d35",
  null
  
)

export default component.exports